import Vue from "vue";
import Vuex from "vuex";
import ticketStore from './modules/ticketStore';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions: {},
  modules: {
    ticketStore,
  }
});
